import { transformItemFromBackend } from "./itemTransformers";
import { normalizeAccessMapUsernames } from "./accessMapUtils";

/**
 * Transforms a backend project/collection record and normalizes accessMap usernames.
 */
export function transformRecordFromBackend(record, itemType, currentUser = null) {
  if (!record) return null;

  const transformed = transformItemFromBackend(record, itemType);
  if (!transformed) return null;

  if (transformed.accessMap) {
    transformed.accessMap = normalizeAccessMapUsernames(
      transformed.accessMap,
      currentUser
    );
  }

  return transformed;
}
